import React from 'react'
import { observer } from 'mobx-react'
import { Dropdown, DropdownTitle, DropdownItem } from 'components/Dropdown'
import Icon from 'components/Icon'
import AdminInventoryManagerViewModel from 'admin/inventory/InventoryManagerViewModel'
import styles from './TableControls.sass'

interface TableControlsProps {
  vm: AdminInventoryManagerViewModel
  button: React.ReactNode
}

export default observer(function TableControls({
  button,
  vm,
}: TableControlsProps) {
  return (
    <>
      <Dropdown autoDismiss position="bottom-end" button={button}>
        <div className={styles.tableControlsContainer}>
          <DropdownTitle>Menu</DropdownTitle>
          <TableControlsItem
            onClick={vm.addInventoryItem}
            icon={
              <Icon
                className={styles.tableControlsItemIcon}
                name="add"
                size={24}
              />
            }
          >
            {vm.workspaceFilter.type === 'Global'
              ? 'Add service item'
              : 'Add workspace item'}
          </TableControlsItem>
        </div>
      </Dropdown>
    </>
  )
})

interface TableControlsItemProps {
  children: React.ReactNode
  icon: React.ReactNode
  active?: boolean
  onClick?: () => void
}

const TableControlsItem = ({
  children,
  icon,
  active,
  onClick,
}: TableControlsItemProps) => (
  <DropdownItem icon={icon} active={active} onClick={onClick}>
    {children}
  </DropdownItem>
)
